import styled, { css } from 'styled-components';
import { variables } from '../../../styles/variables';

const textSharedStyle = css`
  font-size: 1.8rem;
  color: ${variables.colorMainText};
`;
export const Description = styled.span`
  ${textSharedStyle};
`;
export const TitleBox = styled.div`
  h4 {
    ${textSharedStyle};
    font-weight: 700;
  }
  margin-right: 24px;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 24px;
`;

export const ProtocolNotGeneratedSection = styled.section`
  color: ${variables.colorError};
  display: flex;
  align-items: center;

  .anticon {
    font-size: 2.4rem;
    margin-right: 1rem;
  }
`;
